<!--
 * @author:
 * @Description: 新增编辑热点位号选择列表
-->
<template>
  <div class="w-full h-full">
    <el-row :gutter="10">
      <el-col :span="16">
        <el-input v-model="addActiveKeyword" placeholder="输入对象名称" clearable />
      </el-col>
      <el-col :span="4" class="pull-right">
        <el-button type="primary" class="iconfont icon-search" @click="searchList">{{
          `${$t('search')}`
        }}</el-button>
      </el-col>
    </el-row>
    <el-table
      height="420px"
      class="mt-10px"
      :data="activeObjTableData"
      @selection-change="activeObjTableSelectionChange"
      ref="activeObjMultipleTable"
      v-loading="tableLoading"
      border
    >
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column :label="$t('代码')" prop="code" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('名称')" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="别名" prop="identifier" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="status" :label="$t('operate')" width="100">
        <template v-slot="scope">
          <el-button size="mini" @click="confirm(scope.row)">{{ $t('confirm') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-10px"
      @size-change="searchList"
      @current-change="activeObjTableCurrentChange"
      :current-page.sync="activeObjTablePage.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="activeObjTablePage.pageSize"
      layout="->, total, sizes, prev, pager, next"
      :total="activeObjTablePage.total"
      background
    ></el-pagination>
  </div>
</template>

<script>
import documentService from '@/services/DocumentService'

export default {
  name: 'tagsListSearch',
  props: {
    standardId: {
      type: String,
      default: null,
    },
    documentFileId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeObjTableData: [],
      activeObjSelections: [],
      activeObjTablePage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      addActiveKeyword: '',
      tableLoading: false,
    }
  },
  created() {
    this.searchList()
  },
  methods: {
    // 搜索
    searchList() {
      this.activeObjTablePage.pageNo = 1
      this.getActitiveObjTableData()
    },
    // 获取表格数据
    async getActitiveObjTableData() {
      const params = {
        standardId: this.standardId,
        documentFileId: this.documentFileId,
        keyword: this.addActiveKeyword,
        sorting: 'code asc',
        skipCount: this.activeObjTablePage.pageNo,
        maxResultCount: this.activeObjTablePage.pageSize,
      }
      this.tableLoading = true
      const res = await documentService.getTagsList(params)
      this.tableLoading = false
      if (res && res.code === 0) {
        this.activeObjTableData = res.data.map((item) => {
          item.showSurface = true
          return item
        })
        this.activeObjTablePage.total = res.totalCount
      }
    },
    // 表格勾选
    activeObjTableSelectionChange(val) {
      if (val.length > 1) {
        this.$refs.activeObjMultipleTable.clearSelection()
        this.$refs.activeObjMultipleTable.toggleRowSelection(val[val.length - 1])
      } else {
        this.activeObjSelections = val
      }
    },
    // 表格分页
    activeObjTableCurrentChange(val) {
      this.activeObjTablePage.pageNo = val
      this.getActitiveObjTableData()
    },
    // 确定
    confirm(row) {
      this.$emit('selectTagId', row)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
